import { render } from "./toolbar.vue?vue&type=template&id=355d50e0&scoped=true"
import script from "./toolbar.vue?vue&type=script&lang=js"
export * from "./toolbar.vue?vue&type=script&lang=js"

import "./toolbar.vue?vue&type=style&index=0&id=355d50e0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-355d50e0"]])

export default __exports__